import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['tw-flex tw-justify-between tw-items-center'])
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['tw-text-[#FFFFFF] tw-text-[14px] tw-font-semibold'])
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-min-w-[28px] tw-min-h-[28px] tw-bg-[#FFFFFF] tw-rounded-[50%]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#387DFF] tw-text-base tw-font-medium tw-mt-[3px] tw-ml-[1px]" }, "+")
], -1)

import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'buttonAddAnother',
  props: {
  styleButton: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(_component_b_button, {
    variant: "primary",
    class: _normalizeClass(`button-add-another tw-bg-[#387DFF] tw-py-[15px] tw-px-[25px] tw-rounded-md tw-w-full ${props.styleButton}`)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-domain-add-another-button-1",
            )), 1)
          ])
        ]),
        _hoisted_3
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})